import locationHelperBuilder from 'redux-auth-wrapper/history3/locationHelper';
import { connectedRouterRedirect } from 'redux-auth-wrapper/history3/redirect';
import { routerActions } from 'react-router-redux';
import { getToken } from './config/adalConfig';

// import UiSpinner from './components/forms/inputs/UiSpinner';
import {
  isSuperAdmin,
  isAdministrativeProvider,
  isSupervisingPhysician,
  isAdmin,
  isExecutive,
  isClinician,
  isClinicalStaff,
  isPhysiciansAssistant,
  isClinicalPharmacist,
  isManager,
  isStaff,
  isExternalStakeholder,
  isOrganizationalClient,
  isPatientAdvocate,
  isClinicalComplianceManager,
  isClinicalOperationsManager,
  isCareNavigator,
  isMakoAdmin,
  isMakoUser,
} from './store/current-user/CurrentUserSelectors';

const locationHelper = locationHelperBuilder({});

export const userIsAuthenticated = connectedRouterRedirect({
  redirectPath: '/login',
  authenticatedSelector: state =>
    localStorage.getItem('jwt_token') || getToken() ? true : false,
  authenticatingSelector: state => state.currentUser.isLoading,
  // AuthenticatingComponent: UiSpinner,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'UserIsAuthenticated',
});

export const userHasRoles = (component, roles = null) =>
{
  const rolesArr = (roles) ? roles.split(' ') : [];
  const CurrentUserSelectors = {
    isSuperAdmin,
    isAdministrativeProvider,
    isSupervisingPhysician,
    isAdmin,
    isExecutive,
    isClinician,
    isClinicalStaff,
    isPhysiciansAssistant,
    isClinicalPharmacist,
    isManager,
    isStaff,
    isExternalStakeholder,
    isOrganizationalClient,
    isPatientAdvocate,
    isClinicalComplianceManager,
    isClinicalOperationsManager,
    isCareNavigator,
    isMakoAdmin,
    isMakoUser
  };
  let isAllowed = (state, roles) => roles.some(role => CurrentUserSelectors[role](state))
  return connectedRouterRedirect({
    redirectPath: '/',
    allowRedirectBack: false,
    authenticatedSelector: state =>
      (localStorage.getItem('jwt_token') || getToken() ? true : false) &&
      isAllowed(state, rolesArr),
    redirectAction: routerActions.replace,
    wrapperDisplayName: 'userIsStaff',
  })(component);
}
export const userIsNotAuthenticated = connectedRouterRedirect({
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || '/',
  allowRedirectBack: false,
  // Want to redirect the user when they are done loading and authenticated
  authenticatedSelector: state =>
    (localStorage.getItem('jwt_token') || getToken() ? false : true) &&
    state.currentUser.isLoading === false,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'UserIsNotAuthenticated',
});



// WEBPACK FOOTER //
// ./src/auth.js